import { Model } from "../mvvm/Model.js";
const EMAIL = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;
/** ContactMessage is a shared OOP model used by the Contact page across sites. */
export class ContactMessage extends Model {
    name;
    email;
    body;
    constructor(name, email, body) {
        super();
        this.name = name;
        this.email = email;
        this.body = body;
    }
    validate() {
        const errors = [];
        if (this.name.trim() === "")
            errors.push("Name is required.");
        if (!EMAIL.test(this.email))
            errors.push("A valid email is required.");
        if (this.body.trim().length < 10)
            errors.push("Message must be at least 10 characters.");
        return errors;
    }
}
//# sourceMappingURL=ContactMessage.js.map